import VueFormGenerator from 'vue-form-generator';
import CustomFilePicker from './components/CustomFilePicker';
import Vue from 'vue';
import i18n from './i18n';
import lodash from 'lodash';

// applyValidatorsResources();
for (let messageI in VueFormGenerator.validators.resources) {
    VueFormGenerator.validators.resources[messageI] = i18n.t('validators.' + messageI);
}
//custom validator resources
VueFormGenerator.validators.resources['fileNotUploaded'] = i18n.t('validators.fileNotUploaded');
VueFormGenerator.validators.resources['notValidPhoneNumber'] = i18n.t('validators.notValidPhoneNumber');

let customValidators = {
    fileValidator: value => {
        if (value && value.length) {
            return [];
        } else {
            return [VueFormGenerator.validators.resources['fileNotUploaded']];
        }
    },

    fileAmountValidator: (value, field, model) => {
        const requiredAmount = lodash.get(model, field.filesAmountModel, 0);
        VueFormGenerator.validators.resources['wrongFileAmount'] = i18n.t('validators.wrongFileAmount', { amount: requiredAmount });

        if (typeof requiredAmount !== 'number' || requiredAmount === 0) {
            // Валидация отключается
            return [];
        }
        if (!value || value.length !== requiredAmount) {
            return [VueFormGenerator.validators.resources['wrongFileAmount']];
        } else {
            return [];
        }
    },

    phoneNumberValidator: value => {
        if (value) {
            value = value.replace(/\s/g, '');
            if ((value.startsWith('8') && value.length == 11) || (value.startsWith('+7') && value.length == 12)) {
                return [];
            } else {
                return [VueFormGenerator.validators.resources['notValidPhoneNumber']];
            }
        }
    }
};

Vue.component('fieldFilepicker', CustomFilePicker);
Vue.use(VueFormGenerator, { validators: customValidators });
